const dashboardRoutes = [
    {
        path: '/superadmin/dashboard',
        name: 'SuperAdminDashboardPage',
        component: () => import('../views/dashboard/SuperAdminDashboardComponent.vue'),
        meta: {
            requiresAuth: true,
            roles: ['SUPERADMIN'],
        }
    },
    {
        path: '/panel',
        name: 'TenantDashboardPage',
        component: () => import('../views/dashboard/TenantDashboardComponent.vue'),
        meta: {
            requiresAuth: true,
        }
    }
];

export default dashboardRoutes;
